import { styled } from '@mui/material/styles';
import MuiAlert from '@mui/material/Alert';
export const StyledAlert = styled(MuiAlert)(() => ({
  width: '100%',
  backgroundColor: '#E53E3E',
  color: 'white',
  zIndex: 1000,
  border: '1px solid #FC8181',
  '& .MuiAlert-icon': {
    color: 'white',
  },
  '& .MuiAlert-message': {
    color: 'white',
  },
  '& .MuiAlert-action .MuiIconButton-root': {
    backgroundColor: 'transparent !important',
    color: 'white',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    '&:focus': {
      backgroundColor: 'transparent !important',
      boxShadow: 'none !important',
      outline: 'none !important',
    },
  },
  '& .MuiAlert-action .MuiIconButton-root svg': {
    color: 'white',
  },
}));
